// https://zeroheight.com/3fe730a39/p/19a69a-modals/b/801cdd/i/15131337
export const MODAL_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  CLIB: 'creativeLibrary',
  QUICK_ACTIONS: 'quickActions',
};

export type ModalSize = (typeof MODAL_SIZES)[keyof typeof MODAL_SIZES];

export const MODAL_VARIANTS = {
  DEFAULT: 'default',
  DELETE: 'delete',
  WARNING: 'warning',
  INNER_PAGE: 'innerPage',
};

export type ModalVariant = (typeof MODAL_VARIANTS)[keyof typeof MODAL_VARIANTS];
